import { render } from "./KoreaVideoPage.vue?vue&type=template&id=3f561b71&scoped=true"
import script from "./KoreaVideoPage.vue?vue&type=script&lang=js"
export * from "./KoreaVideoPage.vue?vue&type=script&lang=js"

import "./KoreaVideoPage.vue?vue&type=style&index=0&id=3f561b71&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f561b71"]])

export default __exports__